// report-comment.api.ts

import { API } from '../Api';

// Enum for valid report reasons
export enum CommentReportReason {
  Spam = 0,
  Inappropriate = 1,
  HateSpeech = 2,
  Violence = 3,
  Harassment = 4,
  IntellectualPropertyViolation = 5,
  SuicideOrSelfHarm = 6,
  Misinformation = 7,
  ChildEndangerment = 8,
  SexualContent = 9,
  Other = 10,
}
export enum Type {
  Comment = 0,
  Reply = 1,
  ImageComment = 2,
}

// Interface for the request payload
export interface ReportCommentRequest {
  commentId: string;
  reportedByUserId: string;
  commentOwnerId: string;
  reason: CommentReportReason;
  typeComment?: Type;
  note: string;
}

export const createReportCommentApi = (data: ReportCommentRequest) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/user-service/users/created', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const countReportCommentApi = (
  postId: string,
  reportPostValue: string
) => {
  return new Promise<number>((resolve, reject) => {
    API.get(
      `/v1/user-service/users/count?commentId=${postId}&reason=${reportPostValue}`
    )
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const fetchReportCommentsApi = (status = StateReport.Pending) => {
  return new Promise<any>((resolve, reject) => {
    API.post(`/v1/user-service/reportcomments/all?status=${status}`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const fetchCommentByIdApi = (commentId, commentType) => {
  return new Promise<any>((resolve, reject) => {
    API.get(
      `/v1/post-service/comments/get-comment-by-id/${commentId}/${
        commentType === 'Comment' ? 0 : 1
      }`
    )
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const rejectReportCommentApi = (reportCommentId: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/reportcomments/reject/${reportCommentId}`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export const approveReportCommentApi = (postId: string) => {
  return new Promise<any>((resolve, reject) => {
    API.put(`/v1/user-service/reportcomments/approve/${postId}`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};
export enum StateReport {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
}
